var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showSortAndFilter
    ? _c(
        "div",
        [
          _vm.info
            ? _c("collection-banner", {
                attrs: { info: _vm.info, "alternate-image": _vm.alternateImage }
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "container mx-auto mb-5 mt-1_5" },
            [
              _c("collection-sort", {
                attrs: {
                  "sort-options": _vm.sortOptions,
                  "selected-product-type": _vm.selectedProductType,
                  "selected-sort-text": _vm.selectedSortText,
                  "selected-category": _vm.selectedCategory,
                  "selected-parent-category": _vm.selectedParentCategory,
                  "selected-sub-category": _vm.selectedSubCategory,
                  "selected-sub-sub-category": _vm.selectedSubSubCategory,
                  "formatted-product-type": _vm.formattedProductType,
                  categories: _vm.categories,
                  "product-types": _vm.productTypes,
                  "show-mobile-filter-modal": _vm.showMobileFilterModal,
                  "show-mobile-sort-modal": _vm.showMobileSortModal
                },
                on: {
                  "update-state": function($event) {
                    return _vm.$emit("update-state", $event)
                  },
                  "lock-scroll": function($event) {
                    return _vm.$emit("lock-scroll", $event)
                  },
                  "get-campaigns": function($event) {
                    return _vm.$emit("get-campaigns")
                  }
                }
              }),
              _c("div", { staticClass: "flex flex-wrap items-start" }, [
                _c(
                  "div",
                  { staticClass: "w-2-12 hidden md_block" },
                  [
                    _c("collection-filters", {
                      attrs: {
                        "selected-category": _vm.selectedCategory,
                        "selected-product-type": _vm.selectedProductType,
                        categories: _vm.categories,
                        "product-types": _vm.productTypes
                      },
                      on: {
                        "update-state": function($event) {
                          return _vm.$emit("update-state", $event)
                        },
                        "get-campaigns": function($event) {
                          return _vm.$emit("get-campaigns")
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-wrap w-full md_w-10-12 md_border-l md_border-brand-secondary-75 px-1 pt-1 md_pt-2 md_px-2"
                  },
                  [
                    _vm.campaigns.length && !_vm.processing
                      ? _c("product-group", {
                          attrs: {
                            wrap: "wrap",
                            "three-columns": "three-columns",
                            "utm-source": _vm.utmSource,
                            campaigns: _vm.campaigns,
                            "currency-info": _vm.currencyInfo,
                            "is-whitelabel": _vm.isWhitelabel,
                            coupon: _vm.coupon,
                            affiliate: _vm.affiliate
                          },
                          on: {
                            "hide-campaign": function($event) {
                              return _vm.$emit("hide-campaign", $event)
                            }
                          }
                        })
                      : _vm.maxPages === 0 && !_vm.processing
                      ? [
                          _vm.routeName === "collection"
                            ? _c("vs-alert", {
                                attrs: {
                                  message:
                                    "This collection does not contain any products",
                                  type: "table"
                                }
                              })
                            : _vm.routeName === "marketplace"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "text-4xl text-brand mx-auto mt-5"
                                },
                                [_vm._v("No Results Found...")]
                              )
                            : _vm._e()
                        ]
                      : _c(
                          "div",
                          { staticClass: "h-6 mx-auto mt-5" },
                          [
                            _c("vs-logo-loader", {
                              attrs: {
                                "is-whitelabel": _vm.isWhitelabel,
                                slow: "slow"
                              }
                            })
                          ],
                          1
                        )
                  ],
                  2
                ),
                _c("div", { staticClass: "w-2-12 hidden md_block" }),
                _c(
                  "div",
                  { staticClass: "w-full md_w-10-12" },
                  [
                    _c("collection-pagination", {
                      attrs: {
                        processing: _vm.processing,
                        page: _vm.page,
                        pages: _vm.pages,
                        "max-pages": _vm.maxPages
                      },
                      on: {
                        "get-campaigns": function($event) {
                          return _vm.$emit("get-campaigns", $event)
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    : _c(
        "div",
        [
          _vm.info
            ? _c("collection-banner", {
                attrs: { info: _vm.info, "alternate-image": _vm.alternateImage }
              })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "container mx-auto my-4" },
            [
              _vm.campaigns.length
                ? [
                    _c("product-group", {
                      attrs: {
                        wrap: "wrap",
                        "utm-source": _vm.utmSource,
                        campaigns: _vm.campaigns,
                        "currency-info": _vm.currencyInfo,
                        "is-whitelabel": _vm.isWhitelabel,
                        coupon: _vm.coupon,
                        affiliate: _vm.affiliate
                      }
                    }),
                    _c(
                      "div",
                      { staticClass: "w-full" },
                      [
                        _c("collection-pagination", {
                          attrs: {
                            processing: _vm.processing,
                            page: _vm.page,
                            pages: _vm.pages,
                            "max-pages": _vm.maxPages
                          },
                          on: {
                            "get-campaigns": function($event) {
                              return _vm.$emit("get-campaigns", $event)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _c("vs-alert", {
                    attrs: {
                      message: "This collection does not contain any products",
                      type: "table"
                    }
                  })
            ],
            2
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }